import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FormattedMessage, useIntl } from 'react-intl'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import FormikTextField from '../../../../shared/components/formik/FormikTextField'

const VolumeForm = ({ volume, createVolume, updateVolume, onSuccess, onCancel }) => {
  const intl = useIntl()
  const isEditMode = Boolean(volume)

  const validationSchema = Yup.object({
    name: Yup.string(),
    sourcePath: Yup.string(),
    targetPath: Yup.string().required(intl.formatMessage({ id: 'login.error.required' }))
  })

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: volume?.name || '',
      sourcePath: volume?.sourcePath || '',
      targetPath: volume?.targetPath || ''
    },
    validationSchema,
    onSubmit: (values, { setSubmitting, setStatus }) => {
      const volumeData = {
        serviceVolume: {
          name: values.name || null,
          sourcePath: values.sourcePath || null,
          targetPath: values.targetPath
        }
      }

      const apiCall = isEditMode
        ? updateVolume(volume.id, volumeData)
        : createVolume(volumeData)

      apiCall
        .then(() => {
          onSuccess()
        })
        .catch((err) => {
          setStatus(err.message || 'Error saving volume')
        })
        .finally(() => {
          setSubmitting(false)
        })
    }
  })

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <FormikTextField
        formik={formik}
        name="name"
        label={<FormattedMessage id="volumes.form.nameLabel" />}
        autoFocus
      />

      <Box sx={{ mt: 2 }}>
        <FormikTextField
          formik={formik}
          name="sourcePath"
          label={<FormattedMessage id="volumes.form.sourcePathLabel" />}
        />
      </Box>

      <Box sx={{ mt: 2 }}>
        <FormikTextField
          formik={formik}
          name="targetPath"
          label={<FormattedMessage id="volumes.form.targetPathLabel" />}
        />
      </Box>

      {formik.status && (
        <Typography color="error" sx={{ mt: 2 }}>
          {formik.status}
        </Typography>
      )}

      <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
        <Button
          variant="outlined"
          onClick={onCancel}
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="app.actions.cancel.label" />
        </Button>
        <Button
          color="primary"
          variant="contained"
          type="submit"
          disabled={formik.isSubmitting}
        >
          <FormattedMessage id="volumes.form.submitButton" />
        </Button>
      </Box>
    </Box>
  )
}

export default VolumeForm
